import React, { Component } from 'react';
import Nieto from './Nieto.js';

class Hijo extends Component{

    render(){
        return this.props.data.map( nieto =>              
                <Nieto 
                  nieto = {nieto} 
                  key={nieto.id}  
                  deleteNieto={this.props.deleteNieto}
                  chechState={this.props.chechState}
                />);      
    }
}

export default Hijo;